import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';

import { ChartType } from "chart.js";
import { ChartDataSets, ChartOptions } from "chart.js";
import { MultiDataSet, Label, Color, Colors, BaseChartDirective } from "ng2-charts";
import * as _moment from "moment";
import * as pluginDataLabels from "chartjs-plugin-datalabels";
import * as pluginAnnotations from "chartjs-plugin-annotation";
import Swal from 'sweetalert2';

import { Global } from 'src/app/globales/global';
import { NgxSpinnerService } from 'ngx-spinner';
import { TitleCasePipe } from '@angular/common';
import { PaymentsService } from 'src/app/services/payments.service';
import { PaymentsLineChartService } from '../services/chart/payments-line-chart.service';
import { BankPaymentsDayService } from '../services/chart/bank-payments-day.service';
const moment = (_moment as any).default ? (_moment as any).default : _moment;

@Component({
  selector: 'app-bank-payments-day-chart',
  templateUrl: './bank-payments-day-chart.component.html',
  styleUrls: ['./bank-payments-day-chart.component.scss'],
  providers: [TitleCasePipe, Global]
})
export class BankPaymentsDayChartComponent implements OnInit {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input() chartName: string = "";
  public lineChartData: ChartDataSets[] = [];

  public lineChartLabels: Label[] = [];
  public lineChartOptions: ChartOptions & { annotation: any };

  public lineChartColors: Color[] = [];
  public lineChartLegend = true;
  public lineChartType: ChartType = "line";
  public lineChartPlugins = [pluginAnnotations];


  public bankPaymentsByDay: any;
  public paymentsCountVsAmount: any;

  constructor(
    private payments: PaymentsService,
    public titleCasePipe: TitleCasePipe,
    public spinner: NgxSpinnerService,
    public cdRef: ChangeDetectorRef,
    public global: Global,
    private lineChart: BankPaymentsDayService
  ) {
    this.initializeChart();
  }

  ngOnInit(): void {
    this.getBankPaymentsByDay();

  }

  initializeChart() {
    this.lineChartColors = this.lineChart.lineChartColors;
    this.lineChartOptions = this.lineChart.lineChartOptions;
    this.lineChartData = this.lineChart.lineChartData;
    this.lineChartData[0].data = this.lineChart.lineChartData[0].data;
  }


  getBankPaymentsByDay() {
    this.payments.getBankPaymentsByDay().subscribe(
      (bankPaymentsByDayResponse: any) => {
        // console.log('data -> ', bankPaymentsByDayResponse);
        if (bankPaymentsByDayResponse && bankPaymentsByDayResponse.length < 1) {
          this.noDataModal();
          return;
        }
        this.bankPaymentsByDay = bankPaymentsByDayResponse;
        this.bankPaymentsByDay.data.forEach(({ day, totalPays }, idx: number) => {
          this.lineChartData[0].data = [...this.lineChartData[0].data, totalPays];
          this.lineChartLabels = [...this.lineChartLabels, day];
        });
        // this.lineChart.setLabel('  Pagos bancarios por día');
      }, (error: any) => {
        console.log('error -> ', error);
        this.bankPaymentsByDay = [];
        this.noDataModal();
      });
  }

  noDataModal() {
    Swal.fire({
      type: "info",
      title: "No hay información disponible",
      text: "",
    });
  }

}
